export const REVALIDATE_TIME = 3600;

export const EASE = {
  OutQuad: [0.5, 1, 0.89, 1],
  InQuad: [0.11, 0, 0.5, 0],
  InOutQuad: [0.45, 0, 0.55, 1],
}

export const HIGHLIGHT_COLORS = {
  BLUE: 'var(--blue)',
  GREEN: 'var(--green)',
  YELLOW: 'var(--yellow)',
  PINK: 'var(--pink)',
  ORANGE: 'var(--orange)',
}

export const HIGHLIGHT_COLOR_BY_TYPE: Record<string, string> = {
  museum: HIGHLIGHT_COLORS.BLUE,
  brand: HIGHLIGHT_COLORS.GREEN,
  induction: HIGHLIGHT_COLORS.YELLOW,
  features: HIGHLIGHT_COLORS.PINK,
  play: HIGHLIGHT_COLORS.PINK,
  post: HIGHLIGHT_COLORS.PINK,
}

export enum ABSOLUTE_PATHS {
  RRTV = '/rrtv/',
  INDUCTEE_LANDING = '/inductees/'
};

export const LEGACY_REDIRECTS = [
  { from: '/2025-inductees', to: '/inductees/classes/2025/' },
  { from: '/pro-tips', to: '/visit/' },
  { from: '/info', to: '/visit/' },
  { from: '/group-packages', to: '/group-visits/' },
  { from: '/legends', to: ' /exhibit-guide/' },
  { from: '/cities-and-sounds', to: '/exhibitions/cities-and-sounds/' },
  { from: '/cities-and-sounds/[location]' , to: '/exhibitions/cities-and-sounds/' },
  { from: '/roots-of-rock', to: '/exhibitions/roots-of-rock/' },
  { from: '/right-here-right-now', to: '/exhibitions/right-here-right-now/' },
  { from: '/garage', to: '/exhibitions/garage/' },
  { from: '/power-of-rock', to: '/exhibitions/power-of-rock/' },
  { from: '/the-wall', to: '/exhibitions/the-wall/' },
  { from: '/membership-offer', to: '/membership/' },
  { from: '/backstage-stories', to: '/backstage-stories-upgrade' },
  { from: '/all-classes', to: '/inductees/classes/' },
  { from: '/new-vendor', to: '/new-vendors/' },
];